import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { useLocation } from "react-router-dom"
import { getDataDashboard } from '../../../../services/dashboard'
import { getAllOrderList } from '../../../../services/orders'
import { shipmentMethod } from '../../../../helper/master-unit'
import LoadingData from '../../../../component/ui/LoadingData'
import OrderList from '../../../../component/pages/Orders/OrderList'
import NoData from '../../../../component/ui/NoData'
import { Box, Flex, Text, Group, Pagination, Badge, Skeleton } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'

const defaultCondition = {
  salesDivision: [{ id: 9 }, { id: 37 }, { id: 39 }, { id: 44 }, { id: 45 }, { id: 54 }, { id: 55 }, { id: 68 }, { id: 78 }],
  purchaseDivision: [{ id: 10 }, { id: 46 }, { id: 81 }],
  logisticDivision: [{ id: 11 }, { id: 12 }, { id: 47 }],
  aftersalesDivision: [{ id: 13 }, { id: 40 }, { id: 79 }, { id: 80 }],
}

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-order_date',
  include: 'statuses,platform,packages,sales,status_histories',
  'fields[-order]': 'details',
  'fields[order]':
    'id,order_infos,order_code,platform_id,currency_order,order_date,user_id,ordered_by_user_id,origin,destination,shipment_from,shipment_to,grand_total,tracking_code,order_category,order_type,total_logistic_charges,total_custom_charges,shipment_method,updated_at,been_paid,created_at',
  'filter[statuses.id][is]': null,
}

const DivisionListOrder = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const sliceUrl = pathname.split('/')
  const lastSegment = sliceUrl.pop() || sliceUrl.pop()
  const [paramsOrder, setParamsOrder] = useState(defaultParams)
  const [totalOrder, setTotalOrder] = useState(0)
  const [filterStatus, setFilterStatus] = useState([])
  const [orderList, setOrderList] = useState([])
  const [loadingFilter, setLoadingFilter] = useState(true)
  const [loadingOrder, setLoadingOrder] = useState(true)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: null
    },
    {
      label: 'Division',
      route: null
    },
    {
      label: `${lastSegment}`,
      route: null
    },
  ]

  const handleFetchDashboard = async () => {
    setLoadingFilter(true)
    try {
      const response = await getDataDashboard()
      const responseData = response.data
      const dataStatus = responseData ? responseData.managementStats.order.byStatuses : []

      // eslint-disable-next-line
      const filterDivision = dataStatus.filter((val) => {
        let filterSegment = []
        if (lastSegment === 'sales') {
          filterSegment = defaultCondition.salesDivision
        } else if (lastSegment === 'purchase') {
          filterSegment = defaultCondition.purchaseDivision
        } else if (lastSegment === 'logistic') {
          filterSegment = defaultCondition.logisticDivision
        } else if (lastSegment === 'aftersales') {
          filterSegment = defaultCondition.aftersalesDivision
        }
        if (filterSegment.length > 0) {
          return filterSegment.find(value => value.id === val.id)
        }
      })
      if (filterDivision) {
        handleFilter('filter[statuses.id][is]', filterDivision[0].id)
      }
      setFilterStatus(filterDivision)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingFilter(false)
    }
  }

  const handleGetAllOrderList = async () => {
    setLoadingOrder(true)
    try {
      const response = await getAllOrderList(paramsOrder)

      const pickIncludedOrderPaymentStatus = response.included.statuses || []
      const pickIncludedUser = response.included.user || []
      const pickIncludedSales = response.included.sales || []
      const platforms = response.included.platform || []
      const pickStatusHistories = response.included.status_histories || []

      const takeCustomerName = (shipping) => {
        if (shipping.first_name) {
          return `${shipping.first_name !== null ? shipping.first_name : ''} ${shipping.last_name !== null ? shipping.last_name : ''}`
        } else {
          return '-'
        }
      }
      const takeUserName = (userId) => {
        const findName = pickIncludedUser[userId] || ''

        if (findName) {
          const name = findName.attributes.name
          return name
        } else {
          return ''
        }
      }

      const takeSalesName = (salesId) => {
        const findName = pickIncludedSales[salesId] || ''

        if (findName) {
          const name = findName.attributes.name
          return name
        } else {
          return ''
        }
      }
      const takePlatform = (platformId) => {
        const platform = platforms[platformId] || ''

        if (platform) {
          return {
            name: platform.attributes.name,
            label: platform.attributes.label,
            url: platform.attributes.url,
          }
        } else {
          return {
            name: '#Deleted',
            label: 'delete',
            url: '#',
          }
        }
      }

      const takeStatusHistories = (statusId) => {
        const findStatus = pickStatusHistories[statusId] || ''
        if (findStatus) {
          const data = findStatus.attributes
          return data
        } else {
          return null
        }
      }

      const getOrderAndPaymentStatus = (status, payment, id) => {
        let data = null
        status.forEach(s => {
          if(id){
            if(payment){
              const statusInclude = pickIncludedOrderPaymentStatus[s.id]
              if(statusInclude.attributes.type === 1){
                data = statusInclude.attributes.id
              }
            }else {
              const statusInclude = pickIncludedOrderPaymentStatus[s.id]
              if(statusInclude.attributes.type === 2){
                data = statusInclude.attributes.id
              }
            }
          }else if(payment){
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 1){
              data = statusInclude.attributes.name
            }
          }else {
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 2){
              data = statusInclude.attributes.name
            }
          }
        })
        return data
      }

      const getOrderAndPaymentStatusDate = (status, payment) => {
        let data = null
        status.forEach(s => {
          if(payment){
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 1){
              data = statusInclude.attributes.pivot.date
            }
          } else {
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 2){
              data = statusInclude.attributes.pivot.date
            }
          }
        })
        return data
      }

      const dataOrder = response.data
      const remapDataOrder = dataOrder.map((val) => {
        return {
          id: val.attributes.id,
          orderCode: val.attributes.order_code,
          platformId: val.attributes.platform_id,
          platform: takePlatform(val.attributes.platform_id) ,
          orderCurrency: val.attributes.currency_order,
          orderDate: val.attributes.order_date,
          customerName: takeCustomerName(val.attributes.order_infos.shipping || ''),
          orderById: val.attributes.user_id,
          createdByName: takeUserName(val.attributes.user_id),
          agentId: val.attributes.ordered_by_user_id,
          countryProducts: val.attributes.origin,
          destinationProducts: val.attributes.destination,
          shipmentFromId: val.attributes.shipment_from,
          shipmentToId: val.attributes.shipment_to,
          shipmentMethodName: shipmentMethod[val.attributes.shipment_method],
          grandTotal: val.attributes.grand_total,
          paymentStatusId: getOrderAndPaymentStatus(val.relationships.statuses, true, true),
          paymentStatus: getOrderAndPaymentStatus(val.relationships.statuses, true, false),
          paymentStatusDate: getOrderAndPaymentStatusDate(val.relationships.statuses, true),
          orderStatusId: getOrderAndPaymentStatus(val.relationships.statuses, false, true) || '',
          orderStatus: getOrderAndPaymentStatus(val.relationships.statuses, false, false),
          trackingCode: val.attributes.tracking_code,
          dropshipInfo: val.attributes.order_infos.platform,
          salesName: val.relationships.sales !== undefined ? takeSalesName(val.relationships.sales.id) : null,
          orderCategory: val.attributes.order_category,
          orderType: val.attributes.order_type,
          totalLogisticAllIn: val.attributes.total_custom_charges + val.attributes.total_logistic_charges,
          totalPaidByUser: val.attributes.been_paid,
          updatedAt: val.attributes.updated_at,
          createdAt: val.attributes.created_at,
          lastHistoryStatus: val.relationships.status_histories.length > 0 ? takeStatusHistories(val.relationships.status_histories.pop().id) : null,
          markingCode: val.attributes.marking_code,
          terms: val.attributes.terms,
          termsNote: val.attributes.terms_note,
          loadType: val.attributes.load_type,
        }
      })

      setOrderList(remapDataOrder)

      const countOrder = response.meta.pagination.total
      setTotalOrder(countOrder)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingOrder(false)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch, lastSegment])

  useEffect(() => {
    handleFetchDashboard()
    // eslint-disable-next-line
  }, [lastSegment])

  useEffect(() => {
    if (paramsOrder['filter[statuses.id][is]'] !== null) {
      handleGetAllOrderList()
    }
    // eslint-disable-next-line
  }, [paramsOrder])

  const handleFilter = (name, val) => {
    setParamsOrder((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsOrder((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleReloadDataDivision = async () => {
    await handleFetchDashboard()
    handleFilter('filter[statuses.id][is]', paramsOrder['filter[statuses.id][is]'])
    await handleGetAllOrderList()
  }

  const loadingDataFilter = (number) => Array.from({ length: number }, (_, i) => {
    return (
      <Box>
        <Skeleton h={22} w={100} radius='xl' />
      </Box>
    )
  })

  const mappingFilterBadge = (dataStatus) => {

    const handleFilterBadge = (value) => {
      handleFilter('filter[statuses.id][is]', value.id)
      setLoadingOrder(true)
      setTotalOrder(0)
    }

    if (dataStatus.length > 0) {
      const mappingDataFilter = dataStatus.map((val, index) => {
        return (
          <Badge key={index} variant={val.id === paramsOrder['filter[statuses.id][is]'] ? '' : 'outline'} size='lg' onClick={() => handleFilterBadge(val)} style={{ textTransform: 'capitalize', fontWeight: '400', cursor: 'pointer' }} rightSection={<Text fz={12} mt={2}>({val.count})</Text>}>{val.name}</Badge>
        )
      })

      return mappingDataFilter
    }
  }

  const remapDataOrderList = (dataOrder) => {
    const remapData = dataOrder.map((val, index) => {
      return (
        <Box key={index}>
          <OrderList data={val}  type='division' reloadList={handleReloadDataDivision} />
        </Box>
      )
    })
    return remapData
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='flex-start' align="center" mb={30}>
            <Text className={classes.titleLayout} tt='capitalize'>{lastSegment} Division</Text>
          </Flex>
          <Group gap='sm' mb={30}>
            {loadingFilter ? loadingDataFilter(6) : mappingFilterBadge(filterStatus)}
          </Group>
          <Box my={30}>
            <Group mb={10} gap='xs'>
              <Text fz={12}>Total Order Found: </Text>
              <Text fz={12} fw='bold'>{totalOrder} Orders </Text>
            </Group>
            {loadingOrder ? <LoadingData /> : orderList.length > 0 ? remapDataOrderList(orderList) : <NoData />}
          </Box>
          <Flex justify='end'>
            <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalOrder / paramsOrder['page[limit]']) || 0} />
          </Flex>
        </Box>
      </Box>
    </AuthLayout>
  )
}

export default DivisionListOrder